import { CornerRightUpIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Button } from '@/components/ui/button';
import { ResponseMessage } from '@/shared/types/tryIt';

export const GoToResponseButton = ({
  onResponseClick,
  response,
  flat = false,
}: {
  onResponseClick: (id: string) => void;
  response: ResponseMessage;
  /** Adds the hover tooltip. Callers outside the modal render the bare button. */
  flat?: boolean;
}) => {
  const { t } = useTranslation();

  const button = (
    <Button
      variant="ghost-neutral"
      size="icon-sm"
      // Keep the accessible name in sync with the flat tooltip's wording.
      aria-label={t(flat ? 'try_it.go_to_dialog_node' : 'try_it.go_to_response')}
      onClick={() => onResponseClick(response.action_id)}
    >
      <CornerRightUpIcon size={16} />
    </Button>
  );

  if (!flat) {
    return button;
  }

  return (
    <InfoTooltip content={t('try_it.go_to_dialog_node')} side="top">
      {button}
    </InfoTooltip>
  );
};
